<script lang="typescript">
    import { onDestroy } from "svelte";
    import { state, setState } from "./stores.js";
    import {
        MessageType,
        EyeWearType,
        ContactLensWearHoursPerDay,
        ContactLensUseType,
    } from "./types";
    import PrescriptionButton from "./PrescriptionButton.svelte";
    import PrescriptionContinueButton from "./PrescriptionContinueButton.svelte";
    import ContactLensHelpButton from "./ContactLensHelpButton.svelte";

    if (!$state.splashScreenDismissed) {
        window.location.replace("/");
    }

    const selectContactLensType = (contactLensWearHoursPerDay: ContactLensWearHoursPerDay) => {
        setState({
            message: MessageType.SET_CONTACT_LENS_WEAR_HOURS_PER_DAY,
            contactLensWearHoursPerDay,
        });
    };

    const selectContactLensUseType = (contactLensUseType: ContactLensUseType) => {
        setState({
            message: MessageType.SET_CONTACT_LENS_USE_TYPE,
            contactLensUseType,
        });
    };

    const transitionDelay: number = 0;
    let contactLensReady: boolean;
    $: contactLensReady =
        $state.eyeWearType === EyeWearType.CONTACT_LENS &&
        $state.contactLensType !== null &&
        $state.contactLensPrescriptionType !== null &&
        $state.contactLensWearDaysPerWeek !== null &&
        $state.contactLensWearHoursPerDay !== null &&
        $state.contactLensUseType !== null;

    onDestroy(() => window.scrollTo(0, 0));
</script>

<section class="justify-center bg-primary h-screen overflow-y-hidden">
    <div
        class="page-container h-full bg-primary flex flex-col justify-center items-center relative"
    >
        <ContactLensHelpButton />
        <h1 class="text-5xl mb-8 text-white font-normal">Hours worn each day</h1>

        <div class="flex w-full items-center justify-center space-x-8 pt-10">
            {#each Object.values(ContactLensWearHoursPerDay) as label, i}
                <PrescriptionButton
                    transitionParams={{ y: 350, duration: 600, delay: transitionDelay + 200 * i }}
                    onClick={() => selectContactLensType(label)}
                    isSelected={$state.contactLensWearHoursPerDay === label}
                >
                    {@html label}
                </PrescriptionButton>
            {/each}
        </div>

        <h2 class="text-white text-4xl mt-12 font-normal">Daily or reusable</h2>
        {#if $state.contactLensUseType === ContactLensUseType.DAILY}
            <p class="text-white font-normal pt-4 text-xl">
                For cyl of over 2.25 there are more options available in reusable lenses
            </p>
        {/if}
        <div class="flex w-full items-center justify-center space-x-8 pt-10">
            {#each Object.values(ContactLensUseType) as label, i}
                <PrescriptionButton
                    transitionParams={{ y: 350, duration: 600, delay: transitionDelay + 200 * i }}
                    onClick={() => selectContactLensUseType(label)}
                    isSelected={$state.contactLensUseType === label}
                >
                    {@html label}
                </PrescriptionButton>
            {/each}
        </div>

        <div class="flex w-full items-center justify-center space-x-8 pt-16">
            <PrescriptionContinueButton
                isActive={contactLensReady}
                next={"/contact-lenses/lenses/"}
                transitionParams={{ y: 350, duration: 600, delay: 1200 }}
            />
        </div>
    </div>
</section>
